export const changelog = {
  "3.0.0": {
    en: {
      items: [
        "Reuse travelers you've booked before and fill in their details in one tap.",
        "Traveler details, trip overview, and confirmation are clearer and easier to follow.",
        "The price summary is simpler to read, with taxes included in the total.",
        "Passport scanning now shows how clearly your document was read.",
        "Payment is more straightforward, with Tikkie, cash at our office, or bank transfer.",
        "Dates and passenger labels follow the language you selected.",
      ],
    },
    nl: {
      items: [
        "Gebruik reizigers die je eerder hebt geboekt en vul hun gegevens in één keer in.",
        "Reizigersgegevens, reisoverzicht en bevestiging zijn duidelijker en makkelijker te volgen.",
        "Het prijsoverzicht is overzichtelijker, met belastingen inbegrepen in het totaal.",
        "Bij het scannen van je paspoort zie je hoe duidelijk het document is uitgelezen.",
        "Betalen is eenvoudiger, met Tikkie, contant op kantoor of via een bankoverschrijving.",
        "Datums en passagierslabels volgen de taal die je hebt gekozen.",
      ],
    },
  },
  "2.0.0": {
    en: {
      items: [
        "Dutch language support is now available.",
        "Baggage information is clearer, with improved filters and fare messages.",
      ],
    },
    nl: {
      items: [
        "Nu ook Nederlandse taalondersteuning beschikbaar.",
        "Bagage-informatie is duidelijker, met verbeterde filters en tariefmeldingen.",
      ],
    },
  },
};
